<!-- mod icona -->
<div>
  <div>
    <label>{{ "Icona" | translate }}</label>
    <div class="form-check">
      <input
        [value]="'default'"
        [(ngModel)]="iconType"
        (click)="resetIconToLoad()"
        type="radio"
        class="form-check-input"
        id="standardIcon"
        name="standardIcon"
      />
      <label for="form-check-label">{{
        "Usa Icona di default" | translate
      }}</label>
    </div>
    <div class="form-check">
      <input
        [value]="'svg'"
        [(ngModel)]="iconType"
        (click)="resetIconToLoad()"
        type="radio"
        class="form-check-input"
        id="standardIcon"
        name="standardIcon"
      />
      <label for="form-check-label">{{ "Carica Icona" | translate }}</label>
    </div>
    <div class="form-check">
      <input
        [value]="'img'"
        [(ngModel)]="iconType"
        (click)="resetIconToLoad()"
        type="radio"
        class="form-check-input"
        id="standardIcon"
        name="standardIcon"
      />
      <label for="form-check-label">{{
        "Carica un'immagine in formato png o jpg di massimo 1Mb" | translate
      }}</label>
    </div>
  </div>
</div>
<div class="form-group">
  <div *ngIf="iconType === 'default'">
    <div *ngIf="iconToLoad" class="mb-3">
      <img
        class="backGroundImg"
        [src]="
          _DomSanitizationService.bypassSecurityTrustUrl(
            'data:image/svg+xml;base64,' + iconToLoad
          )
        "
        style="width: 100px"
        alt=""
      />
    </div>
    <div style="display: flex; flex-direction: row">
      <button
        data-toggle="modal"
        data-target="#iconsModal"
        data-icon="'service'"
        class="btn btn-secondary"
      >
        {{ "Scegli un icona" | translate }}
      </button>
      <button
        [disabled]="!iconToLoad"
        type="button"
        (click)="resetAllIcon()"
        class="btn btn-danger ml-2"
      >
        {{ "Elimina" | translate }}
      </button>
    </div>
  </div>
  <div *ngIf="iconType === 'svg'">
    <div *ngIf="iconToLoad" class="mb-3">
      <img
        class="backGroundImg"
        [src]="
          _DomSanitizationService.bypassSecurityTrustUrl(
            'data:image/svg+xml;base64,' + iconToLoad
          )
        "
        style="width: 100px"
        alt=""
      />
    </div>

    <div style="display: flex; flex-direction: row">
      <input
        type="file"
        accept=".svg"
        (change)="encodeImageFileAsURL($event.target.files, 3)"
      />
      <button
        type="button"
        (click)="resetAllIcon()"
        class="btn btn-danger ml-2"
      >
        {{ "Elimina" | translate }}
      </button>
    </div>
  </div>
  <div *ngIf="iconType === 'img'">
    <div *ngIf="iconToLoad" class="mb-3">
      <img
        class="backGroundImg"
        [src]="
          _DomSanitizationService.bypassSecurityTrustUrl(
            'data:image/png+xml;base64,' + iconToLoad
          )
        "
        style="width: 100px"
        alt=""
      />
    </div>

    <div style="display: flex; flex-direction: row">
      <input
        type="file"
        accept="image/png, image/jpeg"
        (change)="encodeImageFileAsURL($event.target, 4)"
      />
      <button
        type="button"
        (click)="resetAllIcon()"
        class="btn btn-danger ml-2"
      >
        {{ "Elimina" | translate }}
      </button>
    </div>
  </div>
  <p *ngIf="isMax1Mb" class="text-danger">Immagine maggiore di un 1Mb</p>
</div>

<!-- fine mod icona -->
